import { IMember } from "@wingspanhq/users/dist/lib/interfaces";
import type { onboardingApiSpec } from "@wingspanhq/wingspan-api-types";
import {
  isCountryUS,
  selectorIsDomesticMember
} from "./selectorIsDomesticMember";

export const selectorUseInternationalPayouts = (
  member: IMember,
  monitoredEntity?: onboardingApiSpec.CustomerEntity
): boolean => {
  if (monitoredEntity?.country) {
    return !isCountryUS(monitoredEntity.country);
  }

  return !selectorIsDomesticMember(member);
};
